"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[2364],{

/***/ 62105:
/***/ ((module) => {

module.exports = JSON.parse('{"id":"grafana-azure-monitor-datasource"}');

/***/ })

}]);